import { createAppApi } from '../shared';
import type { APIPayload, APIResponse } from './appConfig';
import type { ParsedValues } from './validation';

// ============================================================================
// PAYLOAD MAPPING
// ============================================================================

export function mapInputToPayload(input: ParsedValues): APIPayload {
  return {
    title: input.title,
    L: input.length,
    W: input.tributaryWidth,
    wadd: input.addedWeight,
    supports: input.supports,
    b: input.b,
    h: input.h,
    rebar: input.rebar,
    rebarDepth: input.rebarDepth,
    shearRebar: input.shearRebar,
    fy: input.fy,
    fc: input.fc,
    density: input.density,
    dif: input.dif,
    axialLoad: input.axialLoad,
    Pa: input.pressureHistory,
    td: input.timeHistory,
    d0: input.u0,
    v0: input.v0
  };
}

const { analyze, analyzeCancellable: analyzeCMUWallCancellable } = createAppApi<ParsedValues, APIPayload, APIResponse>('/iCMUWall/', mapInputToPayload, {
  retry: 2,
  timeout: 15000
});

export { analyze, analyzeCMUWallCancellable };
